import { useCallback, useState } from "react";

import { FetchError } from "utils/errors";

type UseUnlockTofuWorkspaceReturn = {
  unlockWorkspace: (workspaceId: string) => Promise<boolean>;
  loading: boolean;
};

const useUnlockTofuWorkspace = (): UseUnlockTofuWorkspaceReturn => {
  const [loading, setLoading] = useState(false);

  const unlockWorkspace = useCallback(async (workspaceId: string): Promise<boolean> => {
    setLoading(true);

    try {
      const response = await fetch(`/state.v2/workspaces/${workspaceId}/actions/unlock`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new FetchError(response.status);
      }

      return true;
    } catch {
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    unlockWorkspace,
    loading,
  };
};

export default useUnlockTofuWorkspace;
